// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-plugin[data-v-c3f64d8e]{margin-left:5px;position:relative;pointer-events:auto}", ""]);
// Exports
module.exports = exports;
